import type { MouseEvent } from "react";

import { IconButton } from "@similarweb/ui-components";

import { openHooksModalV4, openHooksModalV5, openHooksModalV6 } from "app/services/ModalService";

import type { IHookConfig, ICommonCTAProps } from "../types";

export interface ILockedWithHookCTAProps extends ICommonCTAProps {
    unlockHook: IHookConfig;
}

export const LockedWithHookCTA = ({ unlockHook, label }: ILockedWithHookCTAProps) => (
    <IconButton
        type="flat"
        iconName="locked"
        onClick={(e: MouseEvent) => {
            e.preventDefault();
            switch (unlockHook.version) {
                case "v4":
                    openHooksModalV4(unlockHook.hookModal, null, unlockHook.overrideTrackingKey);
                    break;
                case "v6":
                    openHooksModalV6(unlockHook.hookModal, null, unlockHook.overrideTrackingKey);
                    break;
                default:
                    openHooksModalV5(unlockHook.hookModal);
            }
        }}
    >
        {label}
    </IconButton>
);
